import { render, staticRenderFns } from "./DeviceBarBtns.vue?vue&type=template&id=60b1eaaa&scoped=true&"
import script from "./DeviceBarBtns.vue?vue&type=script&lang=js&"
export * from "./DeviceBarBtns.vue?vue&type=script&lang=js&"
import style0 from "./DeviceBarBtns.vue?vue&type=style&index=0&id=60b1eaaa&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1eaaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
